export const getSession = (name) => {
    return sessionStorage.getItem(name);
};

export const setSession = (name, data) => {
    return sessionStorage.setItem(name, data);
};
